import dayjs from 'dayjs'
import { mdiAlertCircle, mdiCheckCircle } from '@mdi/js'

// Billecta registers payments with a delay, so a just-passed due date is not treated as late.
const OVERDUE_GRACE_DAYS = 3

export type InvoicePaymentStatus = 'paid' | 'overdue' | 'partiallyPaid' | 'open'

// Minimal shape shared by the list item and the invoice detail.
interface InvoicePaymentState {
  dueDate: string
  amounts: {
    invoiced: { value: number }
    paid: { value: number }
    remaining: { value: number }
  }
}

export const getInvoicePaymentStatus = (invoice: InvoicePaymentState): InvoicePaymentStatus => {
  if (invoice.amounts.invoiced.value > 0 && invoice.amounts.remaining.value <= 0) {
    return 'paid'
  }

  if (dayjs().isAfter(dayjs(invoice.dueDate).add(OVERDUE_GRACE_DAYS, 'day'), 'day')) {
    return 'overdue'
  }

  return invoice.amounts.paid.value > 0 ? 'partiallyPaid' : 'open'
}

export const invoiceStatusPresentation = {
  paid: { label: 'Betald', icon: { path: mdiCheckCircle, className: 'status-paid' } },
  overdue: { label: 'Försenad', icon: { path: mdiAlertCircle, className: 'status-overdue' } },
  partiallyPaid: { label: 'Delvis betald', icon: null },
  open: { label: 'Obetald', icon: null },
} as const
